// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inventory-stock-drawer {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 1300;
  display: flex;
  height: 100%;
  width: 80vw;
  max-width: 980px;
  flex-direction: column;
  border-top-left-radius: 24px;
  border-bottom-left-radius: 24px;
  border-left: 1px solid rgba(226, 232, 240, 0.8);
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  shadow: 0 28px 90px rgba(15, 23, 42, 0.22);
  box-shadow: 0 28px 90px rgba(15, 23, 42, 0.22);
  outline: none;
}

.inventory-stock-header {
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.inventory-stock-title {
  font-size: calc(28px + var(--kds-font-delta, 0px));
  font-weight: 500;
  letter-spacing: -0.02em;
  color: #0f172a;
  margin: 0;
}

.inventory-stock-close-btn {
  display: inline-flex;
  height: 36px;
  width: 36px;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  background-color: white;
  color: #64748b;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.2s;
  cursor: pointer;
}

.inventory-stock-close-btn:hover {
  border-color: #cbd5e1;
  background-color: #f8fafc;
  color: #0f172a;
}

.inventory-stock-filters-section {
  padding: 20px 24px;
}

.inventory-stock-filters-card {
  border-radius: 24px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  background-color: rgba(255, 255, 255, 0.9);
  padding: 20px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
  backdrop-filter: blur(4px);
}

.inventory-stock-filters-layout {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
}

.inventory-stock-tabs-container {
  min-width: 0;
  flex: 1;
  overflow-x: auto;
}

.inventory-stock-tabs-container::-webkit-scrollbar {
  display: none;
}

.inventory-stock-tabs-list {
  display: flex;
  min-width: max-content;
  align-items: center;
  gap: 16px;
  padding-right: 4px;
}

.inventory-stock-tab-btn {
  display: inline-flex;
  height: 48px;
  align-items: center;
  gap: 8px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background-color: white;
  padding: 0 16px;
  font-size: calc(14px + var(--kds-font-delta, 0px));
  font-weight: 500;
  color: #64748b;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05);
  transition: all 0.2s;
  cursor: pointer;
}

.inventory-stock-tab-btn:hover {
  border-color: #cbd5e1;
  color: #334155;
}

.inventory-stock-tab-btn.active {
  border-color: #2A71FF;
  background-color: #EFF6FF;
  color: #2A71FF;
  box-shadow: 0 10px 24px rgba(42, 113, 255, 0.16);
}

.inventory-stock-tab-count {
  font-size: calc(14px + var(--kds-font-delta, 0px));
}

.inventory-stock-tab-btn.active .inventory-stock-tab-count {
  color: #2A71FF;
}

.inventory-stock-tab-btn:not(.active) .inventory-stock-tab-count {
  color: #94a3b8;
}

.inventory-stock-search-wrapper {
  display: flex;
  height: 48px;
  width: 100%;
  max-width: 300px;
  flex-shrink: 0;
  align-items: center;
  gap: 8px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background-color: white;
  padding: 0 14px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05);
}

.inventory-stock-search-input {
  width: 100%;
  border: 0;
  background-color: transparent;
  font-size: calc(14px + var(--kds-font-delta, 0px));
  color: #334155;
  outline: none;
}

.inventory-stock-search-input::placeholder {
  color: #94a3b8;
}

.inventory-stock-grid-container {
  position: relative;
  overflow: hidden;
  flex: 1;
  padding: 0 24px 24px 24px;
}

.inventory-stock-grid-viewport {
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.inventory-stock-grid-viewport::-webkit-scrollbar {
  display: none;
}

.inventory-stock-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  padding-right: 12px;
}

.inventory-stock-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 16px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  background-color: white;
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.06);
  transition: transform 0.2s ease;
}

.inventory-stock-card:hover {
  transform: translateY(-2px);
}

.inventory-stock-card-content {
  padding: 16px;
}

.inventory-stock-card-title {
  font-size: calc(18px + var(--kds-font-delta, 0px));
  font-weight: 500;
  line-height: 1.25;
  color: #0f172a;
  margin: 0 0 4px 0;
}

.inventory-stock-card-category {
  font-size: calc(14px + var(--kds-font-delta, 0px));
  color: #64748b;
  margin: 0;
}

.inventory-stock-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  margin-top: auto;
}

.inventory-stock-card-footer.in-stock {
  background-color: #EEF7FF;
}

.inventory-stock-card-footer.low-stock {
  background-color: #FF6B6B;
}

.inventory-stock-status-text {
  font-size: calc(14px + var(--kds-font-delta, 0px));
  font-weight: 600;
}

.in-stock .inventory-stock-status-text {
  color: #2A71FF;
}

.low-stock .inventory-stock-status-text {
  color: white;
}

/* MUI Overrides to match reference switch if possible */
.inventory-stock-switch .MuiSwitch-switchBase.Mui-checked {
  color: #2A71FF
}
.inventory-stock-switch .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
  background-color: #2A71FF !important;
}

/* Custom switch styles to match reference exactly if we don't use MUI Switch */
.custom-switch {
  position: relative;
  display: inline-flex;
  height: 20px;
  width: 36px;
  flex-shrink: 0;
  cursor: pointer;
  align-items: center;
  border-radius: 9999px;
  border: 2px solid transparent;
  transition: background-color 0.2s;
  background-color: #e2e8f0;
}

.custom-switch.checked {
  background-color: #2A71FF;
}

.custom-switch.unchecked-in-red-bg {
  background-color: rgba(255, 255, 255, 0.9);
}

.custom-switch-thumb {
  pointer-events: none;
  display: block;
  height: 16px;
  width: 16px;
  border-radius: 9999px;
  background-color: white;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}

.custom-switch.checked .custom-switch-thumb {
  transform: translateX(16px);
}

.custom-switch.unchecked .custom-switch-thumb {
  transform: translateX(0);
}

/* ═══ DARK THEME — InventoryStock ═══ */
.dark .inventory-stock-drawer {
  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);
  border-left-color: #334155;
}
.dark .inventory-stock-header { border-bottom-color: #334155; }
.dark .inventory-stock-title { color: #f1f5f9; }
.dark .inventory-stock-close-btn {
  background-color: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}
.dark .inventory-stock-close-btn:hover { background-color: #334155; color: #f1f5f9; }
.dark .inventory-stock-filters-card {
  background-color: rgba(30, 41, 59, 0.9);
  border-color: #334155;
}
.dark .inventory-stock-tab-btn {
  background-color: #0f172a;
  border-color: #334155;
  color: #94a3b8;
}
.dark .inventory-stock-tab-btn:hover { border-color: #475569; color: #e2e8f0; }
.dark .inventory-stock-tab-btn.active {
  background-color: rgba(42, 113, 255, 0.15);
  border-color: #2a71ff;
  color: #60a5fa;
}
.dark .inventory-stock-search-wrapper {
  background-color: #0f172a;
  border-color: #334155;
}
.dark .inventory-stock-search-input { color: #e2e8f0; }
.dark .inventory-stock-card {
  background-color: #1e293b;
  border-color: #334155;
}
.dark .inventory-stock-card-title   { color: #f1f5f9; }
.dark .inventory-stock-card-category { color: #64748b; }
.dark .inventory-stock-card-footer.in-stock { background-color: rgba(42, 113, 255, 0.12); }
.dark .custom-switch { background-color: #334155; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/KDS/components/InventoryStock/InventoryStock.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,QAAQ;EACR,aAAa;EACb,aAAa;EACb,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,+BAA+B;EAC/B,+CAA+C;EAC/C,6DAA6D;EAC7D,0CAA0C;EAC1C,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,iDAAiD;EACjD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,0CAA0C;EAC1C,uBAAuB;EACvB,cAAc;EACd,2CAA2C;EAC3C,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;EAC1C,aAAa;EACb,8CAA8C;EAC9C,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;EACd,6CAA6C;EAC7C,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,SAAS;EACT,6BAA6B;EAC7B,kDAAkD;EAClD,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,OAAO;EACP,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,uBAAuB;EACvB,8CAA8C;EAC9C,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kDAAkD;EAClD,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA,wDAAwD;AACxD;EACE;AACF;AACA;EACE,oCAAoC;AACtC;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;EAC7B,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,uBAAuB;EACvB,+CAA+C;EAC/C,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,wCAAwC;AACxC;EACE,6DAA6D;EAC7D,0BAA0B;AAC5B;AACA,gCAAgC,4BAA4B,EAAE;AAC9D,+BAA+B,cAAc,EAAE;AAC/C;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA,yCAAyC,yBAAyB,EAAE,cAAc,EAAE;AACpF;EACE,uCAAuC;EACvC,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA,uCAAuC,qBAAqB,EAAE,cAAc,EAAE;AAC9E;EACE,0CAA0C;EAC1C,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA,sCAAsC,cAAc,EAAE;AACtD;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA,sCAAsC,cAAc,EAAE;AACtD,uCAAuC,cAAc,EAAE;AACvD,8CAA8C,0CAA0C,EAAE;AAC1F,uBAAuB,yBAAyB,EAAE","sourcesContent":[".inventory-stock-drawer {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 1300;\n  display: flex;\n  height: 100%;\n  width: 80vw;\n  max-width: 980px;\n  flex-direction: column;\n  border-top-left-radius: 24px;\n  border-bottom-left-radius: 24px;\n  border-left: 1px solid rgba(226, 232, 240, 0.8);\n  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);\n  shadow: 0 28px 90px rgba(15, 23, 42, 0.22);\n  box-shadow: 0 28px 90px rgba(15, 23, 42, 0.22);\n  outline: none;\n}\n\n.inventory-stock-header {\n  border-bottom: 1px solid rgba(226, 232, 240, 0.8);\n  padding: 20px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.inventory-stock-title {\n  font-size: calc(28px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n  margin: 0;\n}\n\n.inventory-stock-close-btn {\n  display: inline-flex;\n  height: 36px;\n  width: 36px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background-color: white;\n  color: #64748b;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  transition: all 0.2s;\n  cursor: pointer;\n}\n\n.inventory-stock-close-btn:hover {\n  border-color: #cbd5e1;\n  background-color: #f8fafc;\n  color: #0f172a;\n}\n\n.inventory-stock-filters-section {\n  padding: 20px 24px;\n}\n\n.inventory-stock-filters-card {\n  border-radius: 24px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background-color: rgba(255, 255, 255, 0.9);\n  padding: 20px;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);\n  backdrop-filter: blur(4px);\n}\n\n.inventory-stock-filters-layout {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 24px;\n}\n\n.inventory-stock-tabs-container {\n  min-width: 0;\n  flex: 1;\n  overflow-x: auto;\n}\n\n.inventory-stock-tabs-container::-webkit-scrollbar {\n  display: none;\n}\n\n.inventory-stock-tabs-list {\n  display: flex;\n  min-width: max-content;\n  align-items: center;\n  gap: 16px;\n  padding-right: 4px;\n}\n\n.inventory-stock-tab-btn {\n  display: inline-flex;\n  height: 48px;\n  align-items: center;\n  gap: 8px;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  background-color: white;\n  padding: 0 16px;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  color: #64748b;\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05);\n  transition: all 0.2s;\n  cursor: pointer;\n}\n\n.inventory-stock-tab-btn:hover {\n  border-color: #cbd5e1;\n  color: #334155;\n}\n\n.inventory-stock-tab-btn.active {\n  border-color: #2A71FF;\n  background-color: #EFF6FF;\n  color: #2A71FF;\n  box-shadow: 0 10px 24px rgba(42, 113, 255, 0.16);\n}\n\n.inventory-stock-tab-count {\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n}\n\n.inventory-stock-tab-btn.active .inventory-stock-tab-count {\n  color: #2A71FF;\n}\n\n.inventory-stock-tab-btn:not(.active) .inventory-stock-tab-count {\n  color: #94a3b8;\n}\n\n.inventory-stock-search-wrapper {\n  display: flex;\n  height: 48px;\n  width: 100%;\n  max-width: 300px;\n  flex-shrink: 0;\n  align-items: center;\n  gap: 8px;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  background-color: white;\n  padding: 0 14px;\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05);\n}\n\n.inventory-stock-search-input {\n  width: 100%;\n  border: 0;\n  background-color: transparent;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  color: #334155;\n  outline: none;\n}\n\n.inventory-stock-search-input::placeholder {\n  color: #94a3b8;\n}\n\n.inventory-stock-grid-container {\n  position: relative;\n  overflow: hidden;\n  flex: 1;\n  padding: 0 24px 24px 24px;\n}\n\n.inventory-stock-grid-viewport {\n  height: 100%;\n  width: 100%;\n  overflow-y: scroll;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.inventory-stock-grid-viewport::-webkit-scrollbar {\n  display: none;\n}\n\n.inventory-stock-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  padding-right: 12px;\n}\n\n.inventory-stock-card {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border-radius: 16px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background-color: white;\n  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.06);\n  transition: transform 0.2s ease;\n}\n\n.inventory-stock-card:hover {\n  transform: translateY(-2px);\n}\n\n.inventory-stock-card-content {\n  padding: 16px;\n}\n\n.inventory-stock-card-title {\n  font-size: calc(18px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  line-height: 1.25;\n  color: #0f172a;\n  margin: 0 0 4px 0;\n}\n\n.inventory-stock-card-category {\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  color: #64748b;\n  margin: 0;\n}\n\n.inventory-stock-card-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  margin-top: auto;\n}\n\n.inventory-stock-card-footer.in-stock {\n  background-color: #EEF7FF;\n}\n\n.inventory-stock-card-footer.low-stock {\n  background-color: #FF6B6B;\n}\n\n.inventory-stock-status-text {\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  font-weight: 600;\n}\n\n.in-stock .inventory-stock-status-text {\n  color: #2A71FF;\n}\n\n.low-stock .inventory-stock-status-text {\n  color: white;\n}\n\n/* MUI Overrides to match reference switch if possible */\n.inventory-stock-switch .MuiSwitch-switchBase.Mui-checked {\n  color: #2A71FF\n}\n.inventory-stock-switch .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {\n  background-color: #2A71FF !important;\n}\n\n/* Custom switch styles to match reference exactly if we don't use MUI Switch */\n.custom-switch {\n  position: relative;\n  display: inline-flex;\n  height: 20px;\n  width: 36px;\n  flex-shrink: 0;\n  cursor: pointer;\n  align-items: center;\n  border-radius: 9999px;\n  border: 2px solid transparent;\n  transition: background-color 0.2s;\n  background-color: #e2e8f0;\n}\n\n.custom-switch.checked {\n  background-color: #2A71FF;\n}\n\n.custom-switch.unchecked-in-red-bg {\n  background-color: rgba(255, 255, 255, 0.9);\n}\n\n.custom-switch-thumb {\n  pointer-events: none;\n  display: block;\n  height: 16px;\n  width: 16px;\n  border-radius: 9999px;\n  background-color: white;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s;\n}\n\n.custom-switch.checked .custom-switch-thumb {\n  transform: translateX(16px);\n}\n\n.custom-switch.unchecked .custom-switch-thumb {\n  transform: translateX(0);\n}\n\n/* ═══ DARK THEME — InventoryStock ═══ */\n.dark .inventory-stock-drawer {\n  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);\n  border-left-color: #334155;\n}\n.dark .inventory-stock-header { border-bottom-color: #334155; }\n.dark .inventory-stock-title { color: #f1f5f9; }\n.dark .inventory-stock-close-btn {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #94a3b8;\n}\n.dark .inventory-stock-close-btn:hover { background-color: #334155; color: #f1f5f9; }\n.dark .inventory-stock-filters-card {\n  background-color: rgba(30, 41, 59, 0.9);\n  border-color: #334155;\n}\n.dark .inventory-stock-tab-btn {\n  background-color: #0f172a;\n  border-color: #334155;\n  color: #94a3b8;\n}\n.dark .inventory-stock-tab-btn:hover { border-color: #475569; color: #e2e8f0; }\n.dark .inventory-stock-tab-btn.active {\n  background-color: rgba(42, 113, 255, 0.15);\n  border-color: #2a71ff;\n  color: #60a5fa;\n}\n.dark .inventory-stock-search-wrapper {\n  background-color: #0f172a;\n  border-color: #334155;\n}\n.dark .inventory-stock-search-input { color: #e2e8f0; }\n.dark .inventory-stock-card {\n  background-color: #1e293b;\n  border-color: #334155;\n}\n.dark .inventory-stock-card-title   { color: #f1f5f9; }\n.dark .inventory-stock-card-category { color: #64748b; }\n.dark .inventory-stock-card-footer.in-stock { background-color: rgba(42, 113, 255, 0.12); }\n.dark .custom-switch { background-color: #334155; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
